import { useEffect, useState } from "react";
import { usePopupController } from "./usePopupController";

const HERO_PX = 600;

function playingHeroVideo() {
  try {
    const v = document.querySelector("video");
    if (!v) return false;
    const r = v.getBoundingClientRect();
    const visible = r.top < window.innerHeight && r.bottom > 0;
    return visible && !v.paused && !v.ended;
  } catch {
    return false;
  }
}

function eligibleNow() {
  if (typeof window === "undefined") return false;
  const atTop = window.scrollY <= HERO_PX;
  return !atTop && !playingHeroVideo();
}

export function useExitIntentLeadPopup({ enabled = true, sensitivity = 50 }) {
  const [show, setShow] = useState(false);
  const { requestShow } = usePopupController();

  useEffect(() => {
    if (!enabled) return;

    // ignore coarse pointers (touch) for exit intent
    const isTouch = typeof window !== "undefined" && window.matchMedia?.("(pointer: coarse)")?.matches;
    if (isTouch) return;

    const handleMouseOut = (e) => {
      if (e.relatedTarget || e.toElement) return;
      const { clientX, clientY } = e;
      const nearTop = clientY <= 0;
      const nearLeft = clientX <= sensitivity;
      const nearRight = clientX >= window.innerWidth - sensitivity;

      if ((nearTop || nearLeft || nearRight) && eligibleNow()) {
        requestShow("exitIntent");
        if (!show) setShow(true);
        document.removeEventListener("mouseout", handleMouseOut);
      }
    };

    document.addEventListener("mouseout", handleMouseOut);
    return () => document.removeEventListener("mouseout", handleMouseOut);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, requestShow, sensitivity]);

  return { show, setShow };
}
